import { useTranslation } from "@bounce/i18n"

import { StoreCardPoisSectionItem } from "./StoreCardPoisSectionItem"
import { StoreCardSection } from "./StoreCardSection"
import { getPoisWithWalkingTime } from "@/components/LuggageStorage/StoreSlider/utils/helpers"
import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

import WalkIcon from "@bounce/assets/icons/Walk.svg"

const MAX_WALKING_TIME_MINUTES = 30

type StoreCardPoisSectionProps = Pick<NearbyStorageSpot, "coordinates" | "nickname" | "pois">

export const StoreCardPoisSection = ({ nickname, coordinates, pois }: StoreCardPoisSectionProps) => {
  const { i18n } = useTranslation()
  const poisWithWalkingTime = getPoisWithWalkingTime({ coordinates, pois }, i18n)
    // Exclude POIs further than 30 minutes walking time
    .filter(({ walkingTimeInMinutes }) => walkingTimeInMinutes <= MAX_WALKING_TIME_MINUTES)
    // Exclude POIs with the same name as the store nickname
    .filter(({ name }) => name !== nickname)

  if (!poisWithWalkingTime.length) {
    return null
  }

  return (
    <StoreCardSection icon={WalkIcon}>
      <ul>
        {poisWithWalkingTime.map(poi => (
          <StoreCardPoisSectionItem key={poi.id} {...poi} />
        ))}
      </ul>
    </StoreCardSection>
  )
}
